<template>
  <label :class="className"
         :style="style"
         role="checkbox" title="Cliquez pour changer la réponse">
    <input type="checkbox"
           :style="iETrick"
           class="v-switch-input"
           @change.stop="toggle">
    <span class="v-switch-core"
          :style="coreStyle"
          :aria-checked="ariaChecked"></span>
    <div v-if="labels">
      <span class="v-switch-label v-left" v-if="toggled">{{labelChecked}}</span>
      <span class="v-switch-label v-right" v-else>{{labelUnchecked}}</span>
    </div>
  </label>
</template>

<script>
  const DEF_CHECKED_COLOR = '#3c763d'
  const DEF_UNCHEKED_COLOR = '#a94442'

  const DEF_CHECKED_LABEL = 'OUI'
  const DEF_UNCHECKED_LABEL = 'NON'

  const margin = 3

  const contains = (object, title) => {
    return typeof object === 'object' && object.hasOwnProperty(title)
  }

  export default {
    name: 'goSwitch',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      sync: {
        type: Boolean,
        default: true
      },
      color: {
        type: [String, Object],
        validator (value) {
          return typeof value === 'object'
            ? (value.checked || value.unchecked)
            : typeof value === 'string'
        }
      },
      labels: {
        type: [Boolean, Object],
        default: true,
        validator (value) {
          return typeof value === 'object'
            ? (value.checked || value.unchecked)
            : typeof value === 'boolean'
        }
      },
      height: {
        type: Number,
        default: 32
      },
      width: {
        type: Number,
        default: 70
      }
    },
    computed: {
      className () {
        let {toggled, disabled} = this

        return [
          'vue-js-switch',
          {toggled, disabled}
        ]
      },

      ariaChecked () {
        return this.toggled.toString()
      },

      style () {
        let {width, height} = this
        let distance = width - height + margin

        return {
          '--h': height + 'px',
          '--w': width + 'px',
          '--d': distance + 'px'
        }
      },

      colorChecked () {
        if (typeof this.color !== 'object') {
          return this.color || DEF_CHECKED_COLOR
        }

        return contains(this.color, 'checked')
          ? this.color.checked
          : DEF_CHECKED_COLOR
      },

      colorUnchecked () {
        return contains(this.color, 'unchecked')
          ? this.color.unchecked
          : DEF_UNCHEKED_COLOR
      },

      colorCurrent () {
        return this.toggled ? this.colorChecked : this.colorUnchecked
      },

      labelChecked () {
        return contains(this.labels, 'checked')
          ? this.labels.checked
          : DEF_CHECKED_LABEL
      },

      labelUnchecked () {
        return contains(this.labels, 'unchecked')
          ? this.labels.unchecked
          : DEF_UNCHECKED_LABEL
      },

      coreStyle () {
        return {
          'background-color': this.colorCurrent
        }
      }
    },
    watch: {
      value (value) {
        if (this.sync) {
          this.toggled = value
        }
      }
    },
    data: function () {
      return {
        toggled: this.value,
        iETrick: ''
      }
    },
    mounted: function () {
      // IE hack to show at least the checkbox
      if ('ActiveXObject' in window) {
        this.iETrick = 'display:inline-block'
      }
    },
    methods: {
      toggle (event) {
        this.toggled = !this.toggled
        this.$emit('input', this.toggled)
      }
    }
  }
</script>

<style lang="scss" scoped>
  $height: 22px;
  $margin: 3px;

  .vue-js-switch {
    display: inline-block;
    position: relative;
    overflow: hidden;
    vertical-align: middle;
    user-select: none;
    cursor: pointer;
    font-size: $height / 2;

    .v-switch-input {
      display: none;
    }

    .v-switch-label {
      position: absolute;
      top: 0;
      font-weight: 600;
      color: white;

      &.v-left {
        left: 10px;
      }

      &.v-right {
        right: 10px;
      }
    }

    .v-switch-core {
      margin: 0;
      display: inline-block;
      position: relative;

      outline: 0;
      box-sizing: border-box;
      background: #bfcbd9;
      transition: border-color .3s, background-color .3s;
      user-select: none;

      &:before {
        display: block;
        position: absolute;
        overflow: hidden;
        top: 0;
        left: 0;
        z-index: 20;

        transform: translate($margin, $margin);
        transition: transform .3s;

        border-radius: 100%;
        background-color: #fff;
        content: '';
      }
    }

    &.toggled {
      .v-switch-core:before {
        transform: translate(30px, $margin);
        transform: translate(var(--d), $margin);
      }
    }

    &.disabled {
      pointer-events: none;
      cursor: not-allowed;
      opacity: 0.6;
    }
  }

  .vue-js-switch {
    line-height: var(--h);
    height: var(--h);

    .v-switch-label {
      line-height: var(--h);
      height: var(--h);
    }

    .v-switch-core {
      border-radius: 999px;
      width: 60px;
      width: var(--w);
      height: var(--h);

      &:before {
        width: calc(var(--h) - 6px);
        height: calc(var(--h) - 6px);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/goSwitch.vue